<template>
	<div class="tap-option">
		<h3 class="tp-op-title">{{ title }}</h3>

		<div class="tp-op-limit">
			<slot name="limit"></slot>
		</div>
		<div class="tp-op-use">
			<!-- 推荐版本 -->
			<button :class="`button-${type}`" @click="viewDetail">
				{{ actions }}
			</button>
		</div>
		<ul class="tp-op-benifit">
			<li>
				<i class="icon psprite psprite-icon_check"></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT1') }}</span>
			</li>
			<li>
				<i class="icon psprite psprite-icon_check"></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT2') }}</span>
			</li>
			<li>
				<i class="icon psprite psprite-icon_check"></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT3') }}</span>
			</li>
			<li>
				<i class="icon psprite psprite-icon_check"></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT4') }}</span>
			</li>
			<li>
				<i
					:class="{ disable: type === 'free' }"
					class="icon psprite psprite-icon_check"
				></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT5') }}</span>
			</li>
			<li class="upload-file-limit">
				<i
					:class="{ disable: type === 'free' }"
					class="icon psprite psprite-icon_check"
				></i>
				<UploadTip
					:text="getConstants('PRICING_NEW_COMMON_PROFIT6')"
					:content="getConstants('PRICING_NEW_COMMON_PROFIT6_TIP')"
				/>
			</li>
			<li>
				<i
					:class="{ disable: type === 'free' }"
					class="icon psprite psprite-icon_check"
				></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT7') }}</span>
			</li>
			<li>
				<i
					:class="{ disable: type === 'free' }"
					class="icon psprite psprite-icon_check"
				></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT8') }}</span>
			</li>
			<li>
				<i
					:class="{ disable: type === 'free' }"
					class="icon psprite psprite-icon_check"
				></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT9') }}</span>
			</li>
			<li>
				<i
					:class="{ disable: type === 'free' }"
					class="icon psprite psprite-icon_check"
				></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT10') }}</span>
			</li>
			<li>
				<i
					:class="{ disable: type === 'free' }"
					class="icon psprite psprite-icon_check"
				></i>
				<span>{{ getConstants('PRICING_NEW_COMMON_PROFIT11') }}</span>
			</li>
		</ul>
	</div>
</template>
<script>
import { baseData } from '../../../../utils/accountHelper'

import UploadTip from './UploadTip'

export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
		actions: {
			type: String,
		},
	},
	components: { UploadTip },
	computed: {
		priceMoney() {
			const basePrice = {
				free: 0,
				pro: baseData.pro.price,
				advance: baseData.advance.price,
			}
			return basePrice[this.type] || 0
		},
		priceStyle() {
			const baseColor = {
				free: '#b9c8d5',
				pro: '#299bff',
				advance: '#5fb4ff',
			}
			return {
				color: baseColor[this.type],
			}
		},
		isActive() {
			return this.type === 'pro'
		},
	},
	methods: {
		viewDetail() {
			this.$emit('viewDetail')
		},
	},
}
</script>
<style lang="scss" scoped>
.tap-option {
	float: left;
	width: 320px;
	background: #fff;
	height: 800px;
	text-align: center;
	border-radius: 4px;
	border: solid 1px #f1f1f1;
	border-top: none;
	position: relative;
	padding-bottom: 20px;
	&::before {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		height: 6px;
		width: 100%;
		border-top-left-radius: 3px;
		border-top-right-radius: 3px;
	}
	.version-banner {
		position: absolute;
		right: -4px;
		top: -9px;
	}
	&:hover {
		box-shadow: 0 4px 24px 0 rgba(110, 110, 110, 0.05);
	}
}

.tp-op-title {
	padding-top: 30px;
	font-size: 28px;
	line-height: 40px;
}
.tp-op-use {
	padding-top: 28px;
	font-size: 16px;
	button {
		display: block;
		margin: 0 auto;
		width: 236px;
		height: 40px;
		border-radius: 4px;
		font-size: 16px;
		color: $blue;
		cursor: pointer;
		border: solid 2px $blue;
		&:hover {
			color: #fff;
			background-color: $blue;
		}
	}
	.button-pro {
		color: #fff;
		width: 276px;
		background: $blue;
		&:hover {
			background-color: $lightblue;
			border: solid 2px $lightblue;
		}
	}
}

.psprite-icon_check {
	display: inline-block;
	width: 16px;
	height: 16px;
	background: url('../../images/icon_check.png') no-repeat;
}
.disable.psprite-icon_check {
	background: url('../../images/icon_check_grey.png') no-repeat;
}

.tp-op-limit {
	padding-top: 12px;
	font-size: 16px;
	line-height: 24px;
	p {
		padding-top: 20px;
	}
	.limit-tips {
		display: inline-block;
		position: relative;
		margin-left: 4px;
		top: 4px;
		cursor: pointer;
		width: 16px;
	}
}
.upload-file-limit {
	> p {
		justify-content: flex-start;
	}
}
</style>
